<template>
  <div class="sl-carousel">
    <div class="list">
      <div class="thumb" v-for="(item,i) in images"  @click="toggle(i)" >
        <sl-img :previewable="false" :src="item" :public="true"></sl-img>
      </div>
    </div>
    <Modal
      v-model="dialogVisible" 
      :footer-hide="true" 
      class="dialog" 
      transfer 
      width="90%">
      <iCarousel :value="index" v-if="dialogVisible" :autoplay="false" arrow="always">
        <iCarouselItem v-for="item in images" :key="item">
          <sl-img :previewable="false" height="auto" width="auto" class="popup ta-center" :src="item" :public="true"></sl-img>
        </iCarouselItem>
      </iCarousel>
    </Modal>
  </div>
</template>
<script>
import slImg from './img'
import { Carousel as iCarousel , CarouselItem as iCarouselItem } from 'iview'

export default {
  name: 'Carousel',
  components:{slImg,iCarousel,iCarouselItem},
  props: {
    images:{
      type:Array,
      default:function(){
        return []
      }
    }
  },
  data(){
    return {
      dialogVisible:false,
      index:0
    }
  },

 
  mounted(){
    
  },

  methods: {
    toggle(i){
      this.index = i
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss">
.sl-carousel{
  .thumb{
    width:90px;height:90px; 
    display:inline-block;
    margin:5px;
    overflow: hidden;
    border: 1px solid rgba(0,0,0,.05);
    img{
      width:100%;height:100%;
    }
  }

  .popup{
    img{
      height: 300px;
    }
  }
}
  

</style>